import { AppState, AdministratorState } from '@app/redux/states';

const getAdministratorState = ( state: AppState ): AdministratorState | undefined => {
    return state.administrator;
};

export { 
    getAdministratorState,
};
